module.exports = __webpack_public_path__ + "img/content.cd32bc3.png";